import cx from "classnames";

import Icon from "@ide/shared/components/Icon";

import { SOCIAL_MEDIA_CHANNELS } from "@/config";

const icons = {
  tiktok: "fa-tiktok",
  whatsapp: "fa-whatsapp",
  telegram: "fa-telegram",
  facebook: "fa-facebook",
  instagram: "fa-instagram",
  pinterest: "fa-pinterest",
  youtube: "fa-youtube",
};

const SocialMediaList = ({ keyNamespace = "", size = "2x" }) => (
  <ul className="w-full flex justify-between gap-1 text-gray-400 flex-wrap">
    {Object.entries(SOCIAL_MEDIA_CHANNELS).map(([key, url]) => (
      <li key={`${keyNamespace}-${key}`}>
        <a
          href={url}
          className={cx("transition-colors", {
            "hover:text-black": key === "tiktok",
            "hover:text-[#25d366]": key === "whatsapp",
            "hover:text-[#c13584]": key === "instagram",
            "hover:text-[#ff0000]": key === "youtube",
            "hover:text-[#1877f2]": key === "facebook",
            "hover:text-[#e60023]": key === "pinterest",
            "hover:text-[#0088cc]": key === "telegram",
          })}
          target="_blank"
          rel="nofollow noindex"
        >
          <Icon icon={`fa-brands ${icons[key]}`} />
        </a>
      </li>
    ))}
  </ul>
);

export default SocialMediaList;
